import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyle = styled.div`
  width: 100%;
  height: 100%;
  .MuiTextField-root {
    margin-right: 1em;
  }
  .MuiIconButton-colorInherit {
    border-radius: 0px;
    margin-right: 0px;
    padding: 0px;
    height: 1.7em;
  }
  .MuiIcon-colorPrimary {
    color: ${({ theme }) => theme.primary.purple};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${({ theme }) => theme.neutral.gray[3300]};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .MuiTabs-scroller.MuiTabs-fixed {
    @media only screen and (max-width: 1024px) {
      overflow-x: auto !important;
    }
  }
  .MuiTableSortLabel-root {
    width: auto;
    overflow: hidden;
    white-space: nowrap;
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
  .MuiFormControlLabel-root {
    margin-right: 0px;
  }
  .MuiTableCell-root {
    padding: 12px;
  }
  .MuiPaper-root > .MuiToolbar-regular {
    display: none;
  }
`;
export const Convention = styled.div`
  display: flex;
  width: 22em;
  height: auto;
  padding-top: 1em;
  align-items: center;
  margin: auto;
  p {
    margin: 0 1em 0 0.4em;
  }
`;

export const TableConvention = styled.div`
  display: flex;
  height: auto;
  align-items: center;
  p {
    margin: 0 1em 0 0.4em;
  }
`;

export const TextModalDataManagementListResume = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  height: 34em;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[950]};
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme.border.purpleLight}75;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${({ theme }) => theme.neutral.white}73;
    border-radius: 10px;
  }
`;

export const ContentAnswer = styled.div`
  p:nth-child(1) {
    font-size: 16px;
    font-weight: 600;
    text-align: initial;
    margin: 9px 0;
  }
  p:nth-child(2) {
    background: rgba(250, 250, 250, 1);
    border-radius: 3px;
    padding: 0.3em 1.5em;
    text-align: initial;
    display: flex;
    align-items: center;
    min-height: 61px;
  }
`;

export const ContentModalActiveDataManagement = styled.div`
  position: absolute;
  left: 35.2%;
  right: 35.2%;
  top: 3.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: fit-content;
  width: auto;
`;

export const CloseModalActiveDataManagement = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.primaryColorDark};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModalActiveDataManagement = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  height: 8em;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[950]};
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme.border.purpleLight}75;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${({ theme }) => theme.neutral.white}73;
    border-radius: 10px;
  }
`;

export const ButtonActiveDataManagement = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  left: 732px;
  top: 336px;
    background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: ${({ theme }) => theme.neutral.white};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    background-color: ${({ theme }) => theme.button.primaryHover};
  }
`;
export const ButtonActiveDataManagementCancel = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.neutral.white};
  border-radius: 4px;
  border: 1px solid;
  margin: 1em auto;
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const ContentLoader = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
`;

export const ActionSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .right-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;
  }
  .table-action {
    display: flex;
    gap: 0;
  }
`;

export const SearchField = styled.div`
  margin-right: 0.5rem;
  width: 267px;
  height: 40px;
  position: relative;
  background: ${({ theme }) => theme.neutral.white};
  border-radius: 5px;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  svg {
    position: absolute;
    right: 10px;
  }
  input {
    font-size: 12px;
    font-weight: 400;
    border: none;
    outline: none;
    width: 85%;
    box-shadow: none;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: ${({ theme }) => theme.neutral.gray[1300]};
  }
`;

export const TableViewButton = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .list-view {
    color: ${({ iconColor }) => (iconColor ? theme.text.primary : theme.tabs.selected)};
  }
  .card-view {
    color: ${({ iconColor }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;

export const ContentTooltip = styled.div`
  width: 22px;
  height: 22px;
  background-color: ${({ theme }) => theme.button.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  color: white;
`;

export const useStyles = makeStyles(() => ({
  active: {
    "& svg": {
      color: theme.button.primary,
    },
    "&:disabled svg": {
      color: theme.neutral.gray[1200],
    },
  },
  delete: {
    color: theme.status.error,
  },
  buttonActive: () => ({
    background: theme.button.primary,
    color: "white",
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  }),
  closeModalResumeAnswer: {},
  titleOfList: {
    margin: "0.8em 0.45em",
    fontSize: "1.25rem",
    fontWeight: "500",
    lineHeight: "1.6",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  titleAlignment: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "0.5em",
    marginBottom: "1em",
  },
}));
